module.exports = __webpack_public_path__ + "static/img/liveTopBg.aeb7790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rank/liveTopBg.png
// module id = UtPT
// module chunks = 0